<template>
  <div/>
</template>

<script setup lang="ts">
import { watch } from 'vue';
import { useStore } from 'vuex';
import { latestMessage, type WebSocketMessageWithFields, type WebSocketMessageEmpty } from '@/plugins/ws';

import {RootState} from "@/store";

const store = useStore<RootState>();

defineOptions({
  name: 'dataSettings',
});

// Базовый тип для сообщений с ID настройки
type SettingWithId = {
  idSetting: number;
};

// Базовый тип для create операций настроек
type SettingCreateData = SettingWithId & {
  setting: string;
  name: string;
  type: string;
  value: unknown;
};

// Типы для WebSocket сообщений компонента settings
type SettingListMessage = WebSocketMessageWithFields<'setting-list', {
  settings: unknown[];
}>;
type SettingCreateMessage = WebSocketMessageWithFields<'setting-create' | 'setting-create-success', SettingCreateData>;
type SettingUpdateMessage = WebSocketMessageWithFields<'setting-update' | 'setting-update-success', SettingWithId & {
  value: unknown;
}>;
type SettingDeleteMessage = WebSocketMessageWithFields<'setting-delete' | 'setting-delete-success', SettingWithId>;

// Объединенный тип для всех сообщений
type SettingsWebSocketMessage = 
  | SettingListMessage 
  | SettingCreateMessage 
  | SettingUpdateMessage 
  | SettingDeleteMessage;

// WebSocket message handler
const handleWebSocketMessage = (data: SettingsWebSocketMessage): void => {
  if (!data?.signal) return;

  switch (data.signal) {
    case 'setting-list':
      store.dispatch('settings/wsSetSettings', { settings: data.settings });
      break;

    case 'setting-create':
    case 'setting-create-success':
      store.dispatch('settings/wsSettingCreate', {
        idSetting: data.idSetting,
        setting: data.setting,
        name: data.name,
        type: data.type,
        value: data.value,
      });
      break;

    case 'setting-update':
    case 'setting-update-success':
      store.dispatch('settings/wsSettingUpdate', {
        idSetting: data.idSetting,
        value: data.value,
      });
      break;

    case 'setting-delete':
    case 'setting-delete-success':
      store.dispatch('settings/wsSettingDelete', {
        idSetting: data.idSetting,
      });
      break;
  }
};

watch(latestMessage, handleWebSocketMessage);
</script>
